import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const sendReportToEmailId = (data, callback) => {
  return fetchDataAndProceed('/getReport', METHOD_TYPES.GET, data, callback);
};


// WEBPACK FOOTER //
// ./src/data/redux/agent_monitoring_details/api.js